/* global initMediaContainerTabList */

$(() => {
	'use strict';

	document.querySelectorAll('.media-container').forEach(initMediaContainerTabList);

	$('.openOauth').on('click', () => {
		window.showOAuth();
	});

	$('.btn-bildergalerie')
		.attr('href', `${window.location.pathname}#galerie`)
		.on('click', function (e) {
			e.preventDefault();
			$(this).parent().next().modal('show');
		});
	if (window.location.hash === '#galerie') {
		$('.galerie:first').modal('show');
	}

	if ('initModalGalerien' in window) {
		window.initModalGalerien(document);
	}
	if ('initInlineGalerien' in window) {
		window.initInlineGalerien(document);
	}

	if ('initBildDialoge' in window) {
		window.initBildDialoge();
	}
});
